

import { createBrowserRouter } from "react-router-dom";
import React, { Suspense } from "react";
import LazyLoading from "../Utils/LazyLoading";
import { RouterKeys } from "./RouterKeys";
import NonAuthProtect from "./NonAuthProtect";
import AuthProtect from "./AuthProtect";
import ContactUs from "../Screens/Protected/ContactUs/ContactUs";
import ChangePassword from "../Screens/Protected/ChangePassword/ChangePassword";
import MyProfile from "../Screens/Protected/MyProfile/MyProfile";
import EditProfile from "../Screens/Protected/EditProfile/EditProfile";

// Lazy-loaded layouts
const AuthLayout = React.lazy(() => import("../Layout/AuthLayout"));
const NonAuthLayout = React.lazy(() => import("../Layout/NonAuthLayout"));

// Lazy-loaded screens
const Login = React.lazy(() => import("../Screens/Auth/Login"));
const ForgotPassword = React.lazy(() => import("../Screens/Auth/ForgotPassword"));
const Verification = React.lazy(() => import("../Screens/Auth/Verification"));
const NewPassword = React.lazy(() => import("../Screens/Auth/NewPassword"));
const ConfirmPassword = React.lazy(() => import("../Screens/Auth/ConfirmPassword"));
const Dashboard = React.lazy(() => import("../Screens/Protected/Dashboard/Dashboard"));
const User = React.lazy(() => import("../Screens/Protected/User/User"));
const UserDetail = React.lazy(() => import("../Screens/Protected/User/UserDetail"));
const OnBoarding = React.lazy(() => import("../Screens/Protected/OnBoarding/OnBoarding"));
const OnBoardingDetail = React.lazy(() => import("../Screens/Protected/OnBoarding/OnBoardingDetail"));
const FAQ = React.lazy(() => import("../Screens/Protected/FAQ/FAQ"));
const TermsofServices = React.lazy(() => import("../Screens/Protected/TermsofServices/TermsofServices"));
const PrivacyPolicy = React.lazy(() => import("../Screens/Protected/PrivacyPolicy/PrivacyPolicy"));

export const AppRouter = createBrowserRouter([
    {
        path: "/",
        element:
            (
                <AuthProtect>
                    <Suspense fallback={<LazyLoading />}>
                        <AuthLayout />
                    </Suspense>
                </AuthProtect>
            ),
        children: [
            {
                index: true,
                element: <Login />
            },
            {
                path: RouterKeys.AUTH.FORGOT_PASSWORD,
                element: <ForgotPassword />
            },
            {
                path: RouterKeys.AUTH.VERIFICATION,
                element: <Verification />
            },
            {
                path: RouterKeys.AUTH.NEW_PASSWORD,
                element: <NewPassword />
            },
            {
                path: RouterKeys.AUTH.CONFIRM_PASSWORD,
                element: <ConfirmPassword />
            }
        ]
    },
    {

        element:
            (
                <NonAuthProtect>
                    <Suspense fallback={<LazyLoading />}>
                        <NonAuthLayout />
                    </Suspense>
                </NonAuthProtect>
            ),
        children: [
            {
                path: RouterKeys.NON_Auth.DASHBOARD,
                element: <Dashboard />
            },
            {
                path: RouterKeys.NON_Auth.USERS,
                element: <User />
            },
            {
                path: RouterKeys.NON_Auth.USER_Detail,
                element: <UserDetail />
            },
            {
                path: RouterKeys.NON_Auth.ONBOARDING,
                element: <OnBoarding />
            },
            {
                path: RouterKeys.NON_Auth.ONBOARDING_DETAIL,
                element: <OnBoardingDetail />
            },
            {
                path: RouterKeys.NON_Auth.CONTACT_US,
                element: <ContactUs />
            },
            {
                path: RouterKeys.NON_Auth.FAQ,
                element: <FAQ />
            },
            {
                path: RouterKeys.NON_Auth.TERMS_OF_SERVICES,
                element: <TermsofServices />
            },
            {
                path: RouterKeys.NON_Auth.PRIVACY_POLICY,
                element: <PrivacyPolicy />
            },
            {
                path: RouterKeys.NON_Auth.CHANGE_PASSWORD,
                element: <ChangePassword />
            },
            {
                path: RouterKeys.NON_Auth.MY_PROFILE,
                element: <MyProfile />
            },
            {
                path: RouterKeys.NON_Auth.EDIT_PROFILE,
                element: <EditProfile />
            }

        ]
    }
]);
